import React, { useState } from 'react';
import { connect } from 'react-redux';
import '../components.scss';
import { Button, Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker2';
import {
  createPlanItem,
  setObjectiveSelector, setSelectors, validateRequiredFields,
} from '../utils';


const AddNewLead = (props) => {
  const [funnelTypeState, setFunnelType] = useState('');
  const [date, setDate] = useState('');
  const [eventType, setEventType] = useState('');
  const [responsibleState, setResponsible] = useState('');
  const [amount, setAmount] = useState('');
  const {
  	funnelType, responsible, eventTypes,
  } = props;
  const addPlanItem = () => {
    const error = validateRequiredFields(
    	funnelTypeState, responsibleState, eventType, date, amount,
    );
    if (error) {
    	return;
    }
	  const day = `${date._d.getFullYear()}-${(`0${date._d.getMonth() + 1}`).slice(-2)}-${(`0${date._d.getDate()}`).slice(-2)}`;
	  const eventData = {
	  	day,
		  event_type: eventType,
		  responsible: responsibleState,
		  funnel_type: funnelTypeState,
		  amount,
	  };
	  createPlanItem(eventData, props.history.push);
  };
  return (
    <div>
      <div className="lead__container">
        <h3 style={{ color: '#383838', marginBottom: 10 }}>Create new Plan</h3>
        <div className="lead__container__inner" style={{ marginBottom: '1rem' }}>
          <p className="lead__title">
						Date
            <span style={{ color: 'red' }}>*</span>
          </p>
          <DatePicker
            showTodayButton={false}
            timePicker={false}
            className="lead__calendar"
            value={date}
            onChange={(value) => setDate(value)}
          />
        </div>
        <div className="lead__container__inner">
          <p className="lead__title">
						Funnel Type
            <span style={{ color: 'red' }}>*</span>
          </p>
          <Form.Group style={{ width: '50%' }} controlId="formGridState">
            <Form.Control as="select" onChange={({ target: { value } }) => setFunnelType(value)}>
              <option key="" value="">none</option>
              {setSelectors(funnelType)}
            </Form.Control>
          </Form.Group>
        </div>
        <div className="lead__container__inner">
          <p className="lead__title">
						Event Type
            <span style={{ color: 'red' }}>*</span>
          </p>
          <Form.Group style={{ width: '50%' }} controlId="formGridState">
            <Form.Control as="select" onChange={({ target: { value } }) => setEventType(value)}>
              <option key="" value="">none</option>
              {setSelectors(eventTypes)}
            </Form.Control>
          </Form.Group>
        </div>
        <div className="lead__container__inner">
          <p className="lead__title">
						Responsible
            <span style={{ color: 'red' }}>*</span>
          </p>
          <Form.Group style={{ width: '50%' }} controlId="formGridState">
            <Form.Control as="select" onChange={({ target: { value } }) => setResponsible(value)}>
              <option key="" value="">none</option>
              {setObjectiveSelector(responsible)}
            </Form.Control>
          </Form.Group>
        </div>
        <div className="lead__container__inner">
          <p className="lead__title">
						Amount
            <span style={{ color: 'red' }}>*</span>
          </p>
          <Form.Group style={{ width: '50%' }}>
            <Form.Control
              onChange={({ target: { value } }) => setAmount(value)}
              type="number"
            />
          </Form.Group>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            onClick={() => addPlanItem()}
            variant="primary"
            style={{ marginTop: 20 }}
            className="main-button-filled"
          >
					Add new Plan item
          </Button>
        </div>
      </div>
    </div>
  );
};
export default connect((state) => ({
  priorities: state.skillsReducer.priorities,
  funnelStatuses: state.leadReducer.funnelStatuses,
  funnelType: state.leadReducer.funnelType,
  workType: state.leadReducer.workType,
  workTech: state.leadReducer.workTech,
  responsible: state.leadReducer.responsible,
  eventTypes: state.planReducer.eventTypes,
}), { })(AddNewLead);
